/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconFormatNumber/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconFormatNumber({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconFormatNumber",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 14,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconFormatNumber.Svg"
  data-view-path={viewPath}
 viewBox="0 0 14 14"
 style={{'--as-1-GL1dE': alignSelf,'--mt-2-GL1dE': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-GL1dE': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-GL1dE': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-GL1dE': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-GL1dE': opacity,'--w-10-GL1dE': typeof width === 'number' ? `${width}px` : width,'--h-11-GL1dE': typeof height === 'number' ? `${height}px` : height,'--f-12-GL1dE': fill,'--a-7-GL1dE': isAnimated ? animation : "none",'--sd-8-GL1dE': isAnimated ? strokeDashoffset : 0,'--sd-9-GL1dE': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconFormatNumber.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M11.561.389h.533a1.728 1.728 0 011.486 2.61c.262.315.42.72.42 1.162v.178a1.817 1.817 0 01-1.817 1.817h-.71a1.817 1.817 0 01-1.714-1.212.75.75 0 111.414-.5.317.317 0 00.3.212h.71a.317.317 0 00.317-.317V4.16a.317.317 0 00-.317-.317h-.177a.75.75 0 010-1.5h.088a.228.228 0 000-.455h-.533a.228.228 0 00-.22.165.75.75 0 11-1.443-.408A1.728 1.728 0 0111.561.389zm-4.917 0c-.792 0-1.464.506-1.713 1.21a.75.75 0 001.415.5.317.317 0 01.298-.21h.74a.29.29 0 01.115.553l-1.583.693a1.817 1.817 0 00-1.088 1.664v.607c0 .414.335.75.75.75h2.844a.75.75 0 000-1.5h-2.06a.317.317 0 01.155-.147L8.1 3.817A1.79 1.79 0 007.383.389h-.739zm-3.694.75a.75.75 0 10-1.5 0 .317.317 0 01-.317.316H.778a.75.75 0 000 1.5h.355c.108 0 .214-.01.317-.027v1.728H.778a.75.75 0 000 1.5h2.844a.75.75 0 100-1.5H2.95V1.139zm7.828 6.659a.75.75 0 01.817.163l2.185 2.185a.75.75 0 010 1.06l-2.185 2.186a.75.75 0 01-1.28-.53v-1.186H1a1 1 0 110-2h9.315V8.491a.75.75 0 01.463-.693z"
 style={{'--f-12-GL1dE': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}